'use strict';

var _regeneratorRuntime = require("C:\\xampp83\\htdocs\\tangoamistosov2\\smartbooking\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("C:\\xampp83\\htdocs\\tangoamistosov2\\smartbooking\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var _classCallCheck = require("C:\\xampp83\\htdocs\\tangoamistosov2\\smartbooking\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\xampp83\\htdocs\\tangoamistosov2\\smartbooking\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\xampp83\\htdocs\\tangoamistosov2\\smartbooking\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\xampp83\\htdocs\\tangoamistosov2\\smartbooking\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\xampp83\\htdocs\\tangoamistosov2\\smartbooking\\node_modules\\@babel\\runtime/helpers/inherits");

var crypto = require('crypto');

var CryptoProvider = require('./CryptoProvider');
/**
 * `CryptoProvider which uses the Node `crypto` package for its computations.
 */


var NodeCryptoProvider =
/*#__PURE__*/
function (_CryptoProvider) {
  _inherits(NodeCryptoProvider, _CryptoProvider);

  function NodeCryptoProvider() {
    _classCallCheck(this, NodeCryptoProvider);

    return _possibleConstructorReturn(this, _getPrototypeOf(NodeCryptoProvider).apply(this, arguments));
  }

  _createClass(NodeCryptoProvider, [{
    key: "computeHMACSignature",

    /** @override */
    value: function computeHMACSignature(payload, secret) {
      return crypto.createHmac('sha256', secret).update(payload, 'utf8').digest('hex');
    }
    /** @override */

  }, {
    key: "computeHMACSignatureAsync",
    value: function () {
      var _computeHMACSignatureAsync = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(payload, secret) {
        var signature;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.computeHMACSignature(payload, secret);

              case 2:
                signature = _context.sent;
                return _context.abrupt("return", signature);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function computeHMACSignatureAsync(_x, _x2) {
        return _computeHMACSignatureAsync.apply(this, arguments);
      }

      return computeHMACSignatureAsync;
    }()
  }]);

  return NodeCryptoProvider;
}(CryptoProvider);

module.exports = NodeCryptoProvider;